import { PureComponent } from 'react';
import { View, ScrollView, TouchableOpacity, Image } from 'react-native';
import { Text, Button, Popup, DocumentTitle, Loading, TextInput, Label } from '@symbolic/rn-lib';
import { connect } from '@symbolic/redux';
import { resourceActions } from '~/redux';
import { api } from '@symbolic/lib';

import K from '~/k';
import AdminMenu from '~/components/admin-menu';
import SecondaryHeader from '~/components/secondary-header';
import ProductOptionClassifierPopup from '~/components/popups/product-option-classifier-popup';
import { accentColorForOrg } from '~/helpers/org-helper';

import settingsIcon from '~/assets/settings-icon.png';
import createIconWhite from '~/assets/create-icon-white.png';

import React from 'react';
import _ from 'lodash';

class ProductOptionClassifierRow extends PureComponent {
  render() {
    var {productOptionClassifier} = this.props;

    var textCellStyle = {paddingHorizontal: K.spacing};

    return (
      <View
        dataSet={{'hover-background-double-gray': 1, 'conditional-opacity-parent': 1}}
        style={{flexDirection: 'row', alignItems: 'center', height: 30, borderRadius: K.borderRadius, backgroundColor: K.colors.gray, marginBottom: K.margin, marginHorizontal: K.spacing}}
      >
        <View style={{paddingLeft: K.spacing, flexDirection: 'row', flex: 1, height: '100%', alignItems: 'center'}}>
          <Text style={{width: 50, opacity: 0.5, ...textCellStyle}}>{productOptionClassifier.id}</Text>
          <TextInput
            value={_.get(productOptionClassifier, 'title')}
            onChange={({value}) => this.props.updateProductOptionClassifier({id: productOptionClassifier.id, props: {title: value}})}
            style={{backgroundColor: 'transparent', width: 300, marginRight: 20, ...textCellStyle}}
          />
          <TouchableOpacity style={{position: 'absolute', right: 10, opacity: 0.5, ...K.defaultIconSize}} onPress={() => {
            this.props.setActiveProductOptionClassifier({productOptionClassifier});
            this.props.toggleProductOptionClassifierPopupIsVisible();
          }}>
            <Image source={settingsIcon} style={{...K.defaultIconSize}} dataSet={{'conditional-opacity': 1}} />
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

class AdminProductOptionClassifierGroupPage extends PureComponent {
  state = {
    productOptionClassifierGroupSettingsPopupIsVisible: false,
    productOptionClassifierPopupIsVisible: false,
    activeProductOptionClassifier: null,
    isLoading: true
  };

  constructor(props) {
    super(props);
  }

  handleSettingsPopupChange = (value) => this.setState({productOptionClassifierGroupSettingsPopupIsVisible: !value});

  toggleProductOptionClassifierPopupIsVisible = () => this.setState({productOptionClassifierPopupIsVisible: true});

  setActiveProductOptionClassifier = ({productOptionClassifier}) => this.setState({activeProductOptionClassifier: productOptionClassifier});

  async componentDidMount() {
    var productOptionClassifierGroups = await api.get('productOptionClassifierGroups', {where: {id: this.props.productOptionClassifierGroupId, orgId: this.props.session.activeOrg.id}});
    var productOptionClassifiers = await api.get('productOptionClassifiers', {where: {orgId: this.props.session.activeOrg.id, productOptionClassifierGroupId: this.props.productOptionClassifierGroupId}});

    await this.props.trackProductOptionClassifierGroups({productOptionClassifierGroups});
    await this.props.trackProductOptionClassifiers({productOptionClassifiers});

    setTimeout(() => this.setState({isLoading: false}));
  }

  deleteProductOptionClassifierGroup = async () => {
    if (await confirm('Are you sure you want to delete this classifier group?')) {
      this.props.history.push('/admin/product-option-classifier-groups');

      setTimeout(() => {
        this.props.destroyProductOptionClassifierGroup({id: this.props.productOptionClassifierGroup.id});
      });
    }
  };

  createProductOptionClassifier = async () => {
    var productOptionClassifier = await api.create('productOptionClassifier', {
      orgId: this.props.session.activeOrg.id,
      title: 'Untitled Product Option Classifier',
      productOptionClassifierGroupId: this.props.productOptionClassifierGroup.id,
      numbers: {}
    });

    this.props.trackProductOptionClassifiers({productOptionClassifiers: [productOptionClassifier]});
  };

  render() {
    if (this.state.isLoading) {
      return (
        <View style={{flex: 1, flexDirection: 'row'}}>
          <AdminMenu activeOrg={this.props.session.activeOrg} />
          <View style={{flex: 1}}>
            <Loading />
          </View>
        </View>
      );
    }
    else {
      var {productOptionClassifiers, productOptionClassifierGroup} = this.props;

      return (
        <DocumentTitle title={`Admin: ${productOptionClassifierGroup.title} - Product Option Classifier Group`}>
          <View style={{flex: 1, flexDirection: 'row'}}>
            <AdminMenu activeOrg={this.props.session.activeOrg} />
            <View style={{flex: 1}}>
              <SecondaryHeader
                title={productOptionClassifierGroup.title}
                titleIsEditable
                onTitleChange={({value}) => this.props.updateProductOptionClassifierGroup({id: this.props.productOptionClassifierGroup.id, props: {title: value}})}
                subTitle={`ID: ${productOptionClassifierGroup.id}`}
                belowHeaderComponent={(
                  <View style={{marginTop: K.spacing * 2}}>
                    <Button
                      icon={settingsIcon}
                      onPress={() => this.handleSettingsPopupChange(this.state.productOptionClassifierGroupSettingsPopupIsVisible)}
                      style={{backgroundColor: 'transparent', ...K.defaultIconSize}}
                    />
                  </View>
                )}
              ></SecondaryHeader>
              <ScrollView
                horizontal
                contentContainerStyle={{flexDirection: 'column', padding: K.spacing}}
                showsHorizontalScrollIndicator={false}
              >
                {!_.isEmpty(productOptionClassifiers) ? (
                  <View style={{flexDirection: 'column'}}>
                    <View style={{paddingLeft: K.spacing * 2, flexDirection: 'row', marginRight: K.spacing, marginBottom: K.spacing}}>
                      {_.map([
                        {title: 'ID', style: {width: 50}},
                        {title: 'Title', style: {width: 200}}
                      ], ({title, style}, h) => (
                        <View key={h} style={{...style, padding: K.spacing}}>
                          <Label>{title}</Label>
                        </View>
                      ))}
                    </View>
                    {_.map(productOptionClassifiers, (classifier) => (
                      <ProductOptionClassifierRow
                        key={`classifier-${classifier.id}`}
                        productOptionClassifier={classifier}
                        updateProductOptionClassifier={this.props.updateProductOptionClassifier}
                        toggleProductOptionClassifierPopupIsVisible={this.toggleProductOptionClassifierPopupIsVisible}
                        setActiveProductOptionClassifier={this.setActiveProductOptionClassifier}
                      />
                    ))}
                  </View>
                ) : (
                  <View style={{margin: K.spacing, paddingVertical: K.spacing * 4, paddingHorizontal: K.spacing, opacity: 0.5, textAlign: 'center', backgroundColor: K.colors.gray}}>
                    <Text>This group has no classifiers</Text>
                  </View>
                )}
              </ScrollView>
              <TouchableOpacity
                onPress={this.createProductOptionClassifier}
                style={{position: 'fixed', bottom: K.spacing * 2, left: K.spacing * 2, backgroundColor: accentColorForOrg({org: this.props.session.activeOrg}), width: 70, height: 70, borderRadius: 70, alignItems: 'center', 'justifyContent': 'center'}}
              >
                <Image source={createIconWhite} style={{width: K.calc(35), height: K.calc(35)}}/>
              </TouchableOpacity>
            </View>
            {this.state.productOptionClassifierPopupIsVisible && (
              <ProductOptionClassifierPopup
                onClose={() => this.setState({productOptionClassifierPopupIsVisible: false})}
                mode={'admin'}
                productOptionClassifier={this.state.activeProductOptionClassifier}
                updateProductOptionClassifier={this.props.updateProductOptionClassifier}
              />
            )}
            {this.state.productOptionClassifierGroupSettingsPopupIsVisible && (
              <Popup onClose={() => {
                this.handleSettingsPopupChange(this.state.productOptionClassifierGroupSettingsPopupIsVisible);
              }}>
                <Button
                  label='Delete'
                  onPress={this.deleteProductOptionClassifierGroup}
                  style={{backgroundColor: K.colors.deleteRed}}
                />
              </Popup>
            )}
          </View>
        </DocumentTitle>
      );
    }
  }
}

export default connect({
  mapState: (state, ownProps) => {
    var productOptionClassifierGroupId = ownProps.match.params.productOptionClassifierGroupId;
    var productOptionClassifierGroup = _.get(state, `resources.productOptionClassifierGroups.byId[${productOptionClassifierGroupId}]`);
    var productOptionClassifiers = _.filter(state.resources.productOptionClassifiers.byId, classifier => {
      return classifier.productOptionClassifierGroupId === parseInt(productOptionClassifierGroupId) && !classifier.deleted;
    });

    return {
      productOptionClassifierGroupId,
      productOptionClassifierGroup,
      productOptionClassifiers
    };
  },
  mapDispatch: {
    ..._.pick(resourceActions.productOptionClassifierGroups, ['trackProductOptionClassifierGroups', 'updateProductOptionClassifierGroup', 'destroyProductOptionClassifierGroup']),
    ..._.pick(resourceActions.productOptionClassifiers, ['trackProductOptionClassifiers', 'updateProductOptionClassifier'])
  }
})(AdminProductOptionClassifierGroupPage);
